import type { VerbPayload } from '@/core/types';

import type { AppDefinition } from '../types';
import { CardBack } from './CardBack';
import { CardFront } from './CardFront';
import { MissRow } from './MissRow';

/**
 * Verbs — type what the infinitive means.
 *
 * Deliberately not a conjugation trainer. Knowing that `anfangen` means "to
 * start" and being able to produce "hat angefangen" are different tasks, and
 * splitting them is the same call that keeps Nouns and Der·Die·Das apart. The
 * conjugation forms ride along in the payload and show on the card back, so a
 * future conjugation app needs no new extraction.
 */
export const verbsApp: AppDefinition<VerbPayload> = {
  id: 'verbs',
  display_name: 'Verbs',
  CardFront,
  CardBack,
  MissRow,
};
